import React from "react";
import "./Disclaimer.css";

const Disclaimer: React.FC = () => (
  <div className="site-disclaimer">
    <small>
      *These statements have not been evaluated by the Food and Drug Administration. Ravitaj Exim products are not intended to diagnose, treat, cure, or prevent any disease. The information on this website is for educational purposes only and is not a substitute for medical advice, diagnosis or treatment. For more information pertaining to your personal needs please see a qualified health practitioner.
    </small>
  </div>
);

export default Disclaimer;